export const DEFAULT_PHONE_COUNTRY_CODE = "+1";
export const AUTH0_DUPLICATE_PHONE_NUMBER_ERROR =
	"the specified new phone_number already exists";
